import React, { useState, useRef, useEffect } from 'react';
import "./styles.scss";
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import Card from './Card';
import abriJardin from "../../icons/AbriJardin-min.jpg";
import abriModelise from "../../icons/AbriModélisé-min.jpg";
import maisonAvant from "../../icons/MaisonOleronAvant-min.png";
import maisonArriere from "../../icons/MaisonOleronArriere-min.png";
import plansurrelevation from "../../icons/plansurrélévation.jpg";
import surrelevation from "../../icons/surrélévation-min.jpg";
import maisongarage from "../../icons/maisongarage.jpg";
import maisonstudio from "../../icons/maisonstudio.png";
import maisongarage2 from "../../icons/maisongarage2.png";
import maisongaragevisuel from "../../icons/visuelmaisongarage.jpg";
import extensionplan from "../../icons/extensionplan.png";
import extensionplan2 from "../../icons/extensionplan2.png";
import ImageModal from "../ImageModal/index.js";

function CardList() {
  const [selectedCard, setSelectedCard] = useState(null);
  const contentRef = useRef(null);

  const handleClick = (card) => {
    setSelectedCard(card);
  };

  useEffect(() => {
  if (selectedCard && contentRef.current) {
    setTimeout(() => {
      const yOffset = 0; // 🔹 Ajuste ici la hauteur du décalage (en pixels)
      const y = contentRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
      }, 200);
    }
  }, [selectedCard]);


  const cards = [
    { id: 1, title: 'Surélévation en zone submersible', subtitle: 'Transformer une contrainte en véritable opportunité !' , image: plansurrelevation, contenu: 'Construire dans une zone submersible impose des règles strictes: impossible d’agrandir au sol. Mais pourquoi s’arrêter là, quand on peut… prendre de la hauteur ? C’est le pari que nous avons relevé avec ce projet de surélévation. En repensant les volumes existants, nous avons créé de nouvelles chambres baignées de lumière, tout en optimisant chaque mètre carré. Le résultat : une maison agrandie, lumineuse, parfaitement intégrée à son environnement naturel et désormais sécurisée face au risque d’inondation.',picture: surrelevation },
    { id: 2, title: 'Maison avec préau, garage, piscine et studio', subtitle: 'Ce dessin illustre un projet de maison individuelle avec ses annexes et aménagements extérieurs' , image: maisongarage, contenu: 'Le plan de masse présente l’implantation du bâti sur la parcelle, en indiquant les zones de stationnement, les espaces verts et les arbres conservés ou plantés, ainsi que les dimensions principales et les hauteurs de construction. Il précise également l’orientation nord, l’accès au terrain, et la distribution des différentes zones (habitation, préau, garage, piscine, studio), permettant de visualiser l’organisation globale du site et son rapport à l’environnement. Une vue 3D accompagne cette étude, offrant une lecture plus concrète des volumes et de l’agencement architectural. Elle met en valeur les liens entre les espaces intérieurs et extérieurs, ainsi que les ouvertures, les matériaux et les lignes principales du projet. Ce travail illustre une approche complète du dessin architectural, associant lisibilité technique et mise en valeur visuelle du projet.',picture: maisonstudio },
    { id: 3, title: 'Maison avec garage', subtitle:'Voici l’étude complète d’une maison individuelle comprenant un garage, avec les éléments suivants :', image: maisongarage2, contenu: '- Le plan de masse, pour situer la maison sur son terrain et visualiser son intégration dans l’environnement. - Les plans intérieurs, pensés pour offrir une circulation fluide et des espaces lumineux, adaptés au mode de vie des futurs occupants. - Les façades, qui illustrent le style architectural et le choix des matériaux. - L’insertion paysagère, permettant d’apprécier l’harmonie du projet dans son cadre naturel, depuis l’espace public. - Ce visuel met en avant une approche globale du projet, depuis la conception des volumes jusqu’à la représentation finale, dans le respect des contraintes du site et des attentes du maître d’ouvrage.',picture: maisongaragevisuel },
    { id: 4, title: 'Extension sur-mesure', subtitle:'', image: extensionplan, contenu: 'Créer une extension, c’est bien plus qu’ajouter des mètres carrés : c’est repenser les usages, les circulations et les volumes pour offrir un nouvel équilibre à la maison existante. À travers ce projet, nous avons conçu une extension parfaitement intégrée, en cohérence avec l’architecture d’origine et les contraintes du site. Les façades dialoguent avec l’existant, les ouvertures favorisent la lumière naturelle, et l’aménagement intérieur optimise chaque espace pour plus de confort au quotidien. Le résultat : une maison agrandie, harmonieuse et fonctionnelle, où l’ancien et le nouveau se fondent dans une même écriture architecturale.',picture: extensionplan2 },
    { id: 5, title: 'Abri de jardin', image: abriJardin, contenu: 'L’abri de jardin modélisé pour l’autorisation d’urbanisme, puis une photo du même abri une fois construit. Il comprend des lames verticales en bois peint et des tuiles à emboîtement, à l’image des cabanes ostréicoles de l’île d’Oléron.', picture: abriModelise },
    { id: 6, title: 'Maison Oléronaise', image: maisonAvant, contenu: 'La modélisation 3D permet de bien visualiser une future construction. Ici, une maison qui respecte l’aspect traditionnel de l’île d’Oléron: enduit blanc, tuiles à emboîtement, pente de toit entre 28 et 33%, ouvertures plus hautes que larges et volets bois.', picture: maisonArriere },
    ];

  return (
  <div className='realisations'>
    <h2 className='realisations-title'>- Réalisations -</h2>
      <div className='realisations-card'>
      {cards.map((card) => (
        <Card
          key={card.id}
          title={card.title}
          subtitle={card.subtitle}
          image={card.image}
          picture={card.picture}
          handleClick={() => handleClick(card)}
        />
      ))}
      </div>
      {selectedCard && (
        <div ref={contentRef} className='realisations-card-selected'>
          <ImageModal  src={selectedCard.image} alt={selectedCard.title} />
          <div className='realisations-card-selected-element'>
            <h3 className='realisations-card-selected-title'>{selectedCard.title}</h3>
            <h4 className='realisations-card-selected-subtitle'>{selectedCard.subtitle}</h4>
            <p className='realisations-card-selected-text'>
            {selectedCard.contenu.split(' - ').map((part, index) => (
            <React.Fragment key={index}>
            {index > 0 && <><br />- </>}
            {part}
            </React.Fragment>
            ))}
            </p>
            <ImageModal className='realisations-card-selected-picture' src={selectedCard.picture} alt={selectedCard.title} />
          </div>
        </div>
      )}
      <div className='realisations-element'>
        <div className='realisations-map'>
        <MapContainer center={[47.093970, 0.369840]} zoom={6} scrollWheelZoom={true}>
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={[45.744175, -0.633389]}></Marker>
            <Marker position={[46.152744, -1.093788]}> </Marker>
            <Marker position={[45.847459, -1.147392]}></Marker>
            <Marker position={[48.799660, 2.173231]}></Marker>
            <Marker position={[45.942759, -1.307189]}></Marker>
            <Marker position={[46.014664, -1.349118]}></Marker>
            <Marker position={[45.961174, -1.378412]}></Marker>
            <Marker position={[45.972756, -1.378459]}></Marker>
            <Marker position={[45.959886, -1.323709]}></Marker>
            <Marker position={[45.882146, -1.255101]}></Marker>
            <Marker position={[45.841986, -1.207759]}></Marker>
            <Marker position={[45.861295, -1.238474]}></Marker>
            <Marker position={[45.933149, -1.294946]}></Marker>
            <Marker position={[45.893783, -1.224483]}></Marker>
            <Marker position={[45.909066, -1.239821]}></Marker>
            <Marker position={[45.940034, -1.337281]}></Marker>
            <Marker position={[45.984069, -1.310069]}></Marker>
            <Marker position={[45.969303, -1.295433]}></Marker>
            <Marker position={[45.872397, -1.206990]}></Marker>
            <Marker position={[45.915608, -1.299293]}></Marker>
            <Marker position={[45.936916, -1.356848]}></Marker>
            <Marker position={[45.972325, -1.350157]}></Marker>
            <Marker position={[45.97037, -1.29566]}></Marker>
            <Marker position={[45.96997, -1.29792]}></Marker>
            <Marker position={[45.97498, -1.30142]}></Marker>
            <Marker position={[45.98786, -1.31034]}></Marker>
            <Marker position={[45.98447, -1.30932]}></Marker>   
            <Marker position={[45.98671, -1.31357]}></Marker>
            <Marker position={[45.98599, -1.37280]}></Marker>            
            <Marker position={[45.97849, -1.39106]}></Marker>
            <Marker position={[45.97855, -1.39334]}></Marker>
            <Marker position={[45.97248, -1.34902]}></Marker>
            <Marker position={[45.96187, -1.37706]}></Marker>
            <Marker position={[45.96389, -1.36269]}></Marker>
            <Marker position={[45.95334, -1.33319]}></Marker>
            <Marker position={[45.94370, -1.30356]}></Marker>
            <Marker position={[45.95203, -1.31882]}></Marker>
            <Marker position={[45.93316, -1.29516]}></Marker>
            <Marker position={[45.93709, -1.35590]}></Marker>
            <Marker position={[45.93848, -1.32773]}></Marker>
            <Marker position={[45.94395,-1.28842]}></Marker>
            <Marker position={[45.92566, -1.32091]}></Marker>
            <Marker position={[45.90790, -1.25940]}></Marker>
            <Marker position={[45.91164, -1.27071]}></Marker>
            <Marker position={[45.93123, -1.25703]}></Marker>
            <Marker position={[45.90329, -1.26107]}></Marker>
            <Marker position={[45.90206, -1.28167]}></Marker>
            <Marker position={[45.90516, -1.25906]}></Marker>
            <Marker position={[45.88723, -1.19591]}></Marker>
            <Marker position={[45.93326, -1.34171]}></Marker>
            <Marker position={[45.92591, -1.23452]}></Marker>
            <Marker position={[46.01714, -1.35546]}></Marker>
            <Marker position={[46.01210, -1.34104]}></Marker>
            <Marker position={[46.03946, -1.40098]}></Marker>
            <Marker position={[46.04167, -1.40335]}></Marker>
            <Marker position={[46.04380, -1.39728]}></Marker>
            <Marker position={[46.02711, -1.36946]}></Marker>
            <Marker position={[46.03407, -1.38160]}></Marker>
            <Marker position={[46.02738, -1.36667]}></Marker>
            <Marker position={[45.99257, -1.34657]}></Marker>
            <Marker position={[45.96857, -1.24245]}></Marker>
            <Marker position={[46.00857, -1.39016]}></Marker>
            <Marker position={[45.97913, -1.33254]}></Marker>
            <Marker position={[45.60380, -0.98397]}></Marker>
            <Marker position={[44.77426, -0.35027]}></Marker>
            <Marker position={[47.42545, 3.99724]}></Marker>
            <Marker position={[45.91787, -1.32939]}></Marker>
          </MapContainer>
        </div>
    </div>
  </div>
  );
}

export default CardList;